// extracted by mini-css-extract-plugin
export default {"content":"adicionarLivro_content__LmAnk","moldura":"adicionarLivro_moldura__0ijz6","displayColumn":"adicionarLivro_displayColumn__U18sH","inputs":"adicionarLivro_inputs__D9XYR"};